import PropTypes from "prop-types";

import { isFunction } from "../utils";
import { useTableState } from "../hooks";

const TableState = ({ render }) => {
  const tableState = useTableState();

  /* istanbul ignore if */
  if (!isFunction(render)) {
    return null;
  }

  return render(tableState);
};

TableState.propTypes = {
  render: PropTypes.func
};

export default TableState;
